import type { FC } from "react";
import type { ClientPortfolioToolReportingSummaryResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import { getRowKey } from "web_myplann/Portfolio/Helpers/getRowKey";
import {
	type NormalizedTool,
	ToolKind,
} from "web_myplann/Portfolio/Helpers/investmentToolTypes";
import { BankProductToolRow } from "./BankProductToolRow";
import { BondToolRow } from "./BondToolRow";
import { CommodityToolRow } from "./CommodityToolRow";
import { CryptoToolRow } from "./CryptoToolRow";
import { InvestmentToolRow } from "./InvestmentToolRow";

type Props = {
	tools: NormalizedTool[];
	portfolioId: number;
	currencySign: string;
	toolsSummary?: ClientPortfolioToolReportingSummaryResponseDTO[];
	expandedMap: Record<string, boolean>;
	setExpanded: (key: string, value: boolean) => void;
	noDivider: boolean;
};

export const ToolRowList: FC<Props> = ({
	tools,
	portfolioId,
	currencySign,
	toolsSummary,
	expandedMap,
	setExpanded,
	noDivider,
}) => {
	return (
		<>
			{tools.map((tool, toolIdx) => {
				const rowKey = getRowKey(tool);
				const isLastItem = toolIdx === tools.length - 1;

				const commonProps = {
					portfolioId,
					currencySign,
					toolsSummary,
					expanded: !!expandedMap[rowKey],
					onToggle: (v: boolean) => setExpanded(rowKey, v),
					noDivider: isLastItem && noDivider,
				};

				switch (tool.kind) {
					case ToolKind.Commodity:
						return (
							<CommodityToolRow key={rowKey} tool={tool} {...commonProps} />
						);
					case ToolKind.Crypto:
						return <CryptoToolRow key={rowKey} tool={tool} {...commonProps} />;
					case ToolKind.Investment:
						return (
							<InvestmentToolRow key={rowKey} tool={tool} {...commonProps} />
						);
					case ToolKind.Bond:
						return <BondToolRow key={rowKey} tool={tool} {...commonProps} />;
					case ToolKind.BankProduct:
						return (
							<BankProductToolRow key={rowKey} tool={tool} {...commonProps} />
						);
					default:
						return null;
				}
			})}
		</>
	);
};
